import { render, staticRenderFns } from "./termlyContent.vue?vue&type=template&id=73b4c1ce&scoped=true"
import script from "./termlyContent.vue?vue&type=script&lang=js"
export * from "./termlyContent.vue?vue&type=script&lang=js"
import style0 from "./termlyContent.vue?vue&type=style&index=0&id=73b4c1ce&prod&lang=scss&scoped=true"
import style1 from "./termlyContent.vue?vue&type=style&index=1&id=73b4c1ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b4c1ce",
  null
  
)

export default component.exports